/**
 * Универсальная утилита экспорта в CSV.
 * Без deps — работает в любом браузере.
 */

type CellValue = string | number | boolean | null | undefined | Date;

export interface CsvColumn<T> {
  header: string;
  accessor: (row: T) => CellValue;
}

function escapeCsvCell(value: CellValue): string {
  if (value == null) return '';
  let s: string;
  if (value instanceof Date) {
    s = value.toISOString();
  } else if (typeof value === 'boolean') {
    s = value ? 'true' : 'false';
  } else {
    s = String(value);
  }
  // Excel-friendly: оборачиваем в кавычки если есть спец-символы
  if (s.includes(',') || s.includes('"') || s.includes('\n') || s.includes('\r')) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function rowsToCsv<T>(rows: T[], columns: CsvColumn<T>[]): string {
  const header = columns.map((c) => escapeCsvCell(c.header)).join(',');
  const body = rows
    .map((row) => columns.map((c) => escapeCsvCell(c.accessor(row))).join(','))
    .join('\r\n');
  // BOM для корректного открытия Excel'ем (UTF-8)
  return '﻿' + header + '\r\n' + body;
}

export function downloadCsv(csv: string, filename: string): void {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export function exportToCsv<T>(
  rows: T[],
  columns: CsvColumn<T>[],
  filename: string,
): void {
  const csv = rowsToCsv(rows, columns);
  downloadCsv(csv, filename);
}
